import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/lenis";
import { trackContact } from "@/lib/analytics";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Destinations } from "@/components/Destinations";
import { Process } from "@/components/Process";
import { Eligibility } from "@/components/Eligibility";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import DestinationPage from "@/pages/DestinationPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location.pathname]);
  return null;
};

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Destinations />
      <Process />
      <Eligibility />
      <Testimonials />
      <Faq />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      if (e.target.closest('a[href*="wa.me"]')) trackContact("whatsapp");
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinos/:id" element={<DestinationPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacidade" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
